document.addEventListener("DOMContentLoaded", function() {
    var customAdd = document.querySelector(".custom-rig-ads");
    var customOrderDiv = document.querySelector(".custom-orderr");
    var customContactDiv = document.querySelector(".custom-contant");
    var customRecentlyViewedDiv = document.querySelector(".custom-recently-viewed");
    var customTopSelling = document.querySelector(".custom-top-selling");
    var customTrackOrder = document.querySelector(".custom-track-ord");
    var customTicketsAPI = document.querySelector(".custom-tickets-api");
    var allLinks = document.querySelectorAll(".cstm-a");
    var subtitleText = document.getElementById("subtitle-text");

    function updateSubtitleText(newText) {
        subtitleText.textContent = newText;
    }

    function removeActiveClass() {
        allLinks.forEach(function(link) {
            link.classList.remove("active");
        });
        var headerLinks = document.querySelectorAll(".header-cstm-a");
        headerLinks.forEach(function(link) {
            link.classList.remove("active");
        });
    }

    function hideAllSections() {
        customAdd.style.display = "none";
        customOrderDiv.style.display = "none";
        customContactDiv.style.display = "none";
        customRecentlyViewedDiv.style.display = "none";
        customTopSelling.style.display = "none";
        customTrackOrder.style.display = "none";
        customTicketsAPI.style.display = "none";
    }
    function activateTab(tabName) {
        hideAllSections();
        removeActiveClass();
        var linkToActivate = document.querySelector(`.cstm-a[href*='${tabName}']`);
        
        var headerLinkToActivate = document.querySelector(`.header-cstm-a[href*='${tabName}']`);

        if (linkToActivate) {
            linkToActivate.classList.add("active");
            updateSubtitleText(linkToActivate.getAttribute("data-subtitle"));
        }
        if (headerLinkToActivate) {
            headerLinkToActivate.classList.add("active");
        }

        switch (tabName) {
            case "my_order":
                customOrderDiv.style.display = "block";
                break;
            case "contact":
                customContactDiv.style.display = "block";
                break;
            case "recently_viewed":
                customRecentlyViewedDiv.style.display = "block";
                break;
            case "top_order_products":
                customTopSelling.style.display = "block";
                break;
            case "track_order":
                customTrackOrder.style.display = "block";
                break;
            case "tickets":
                customTicketsAPI.style.display = "block";
                break;
            default:
                // Show customAdd section and add active class to corresponding link
                customAdd.style.display = "block";
                var defaultLink = document.querySelector(".cstm-a[href='/account']");
                var defaultHeaderLink = document.querySelector(".header-cstm-a[href='/account']");
                if (defaultLink) {
                    defaultLink.classList.add("active");
                    updateSubtitleText(defaultLink.getAttribute("data-subtitle"));
                }
                if (defaultHeaderLink) {
                    defaultHeaderLink.classList.add("active");
                }
                break;
        }
    }

    var urlParams = new URLSearchParams(window.location.search);
    var activeTab = urlParams.get("tab");
    if (activeTab) {
        activateTab(activeTab);
    } else {
        activateTab(""); // Activate the default tab if no tab is specified
    }
    allLinks.forEach(function(link) {
        link.addEventListener("click", function(event) {
            var tab = link.getAttribute("href").split("=")[1];
            if (tab) {
                event.preventDefault();
                history.pushState(null, "", `/account?tab=${tab}`);
                activateTab(tab);
            } else {
                // Handle Addresses link separately
                removeActiveClass();
                link.classList.add("active");
                history.pushState(null, "", "/account");
                updateSubtitleText(link.getAttribute("data-subtitle"));
                hideAllSections();
                customAdd.style.display = "block";
            }
        });
    });
    document.addEventListener("click", function(event) {
        if (event.target.matches(".header-cstm-a")) {
            var tab = event.target.getAttribute("href").split("=")[1];
            if (tab) {
                event.preventDefault();
                history.pushState(null, "", `/account?tab=${tab}`);
                activateTab(tab);
            }
        }
    });
  });